module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/Users/gbelizaire/Documents/ang2tut/resulatbac/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0